import { action, observable, makeObservable } from 'mobx';
import {ContentLookup, SuccessResponse} from '../../../../domain';
import {HttpPromiseState} from '../../../../lib/helpers';
import {Classroom} from '../../../classroom/models/classroom-models';
import {ClassroomLoaders} from '../../../classroom/stores/classroom-loaders';
import {AdminClassroomSceneStore} from '../AdminClassroomSceneStore';
import {ClassroomEditFormStore} from './ClassroomEditFormStore';

export class ClassroomEditStore {
  form: ClassroomEditFormStore;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly parent: AdminClassroomSceneStore,
              readonly classroom: Classroom,
              private lookup: ContentLookup) {
    makeObservable(this);
    this.form = new ClassroomEditFormStore(lookup);
    this.form.setStudent(classroom.Student);
    this.form.setTeacher(classroom.Teacher);
    this.form.setStartTime(classroom.ScheduledStartTime);
    this.form.status.setValue(classroom.Status);
    this.form.setLesson(classroom.Lesson);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.form.markAllTouched();
    if (!this.form.valid)
      return;
    this.save = ClassroomLoaders.Admin.updateClassroom(this.classroom.Id, this.form.model);
  }

  dispose = () => {
    this.form.dispose();
  };
}
